import { useRef, useState } from "react";
import Swal from "sweetalert2";
import { decryptData, defaulUrl, Loading } from "../components/const";



const ModalAddPartenaire = ({ part }) => {
    const [nom, setNom] = useState(null);
    const [telephone, setTelephone] = useState(null);
    const [genre, setGenre] = useState(null);
    const [adresse, setAdresse] = useState(null);
    const [email, setEmail] = useState('')
    const [errors, setErrors] = useState(null)
    const [loader, setLoader] = useState(false)
    const ref = useRef()
    const handleSubmite = (e) => {
        e.preventDefault();

        setLoader(true);
        const formdata = new FormData(e.target);

        let status = 0;
        fetch(`${defaulUrl}confier/add`, {
            method: "POST",
            headers: {
                Accept: 'application/json',
                ContentType: 'application/json',
                Authorization: `Bearer ${decryptData('ACCESS_TOKEN')}`
            },

            body: formdata
        }).then((response) => {
            status = response.status;
            return response.json()
        }).then(data => {
            setLoader(false);
            if (status === 200) {
                Swal.fire({
                    title: 'Succès',
                    text: data.message,
                    icon: 'success'
                }).then(() => {

                    ref.current.click();
                })
            } else {
                setErrors(data.errors);
            }
        })
        setErrors(null);
    }
    return (
        <div className="modal fade " id="modalAddpartenaire" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header bg-secondary-subtle">
                        <h1 className="modal-title fs-6" id="exampleModalLabel">Ajouter un partenaire</h1>
                        <button type="button " className="btn-close btn-danger" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <form onSubmit={(e) => handleSubmite(e)}>
                        <div className="modal-body position-relative">
                            <div className="row">

                                <div className="form-group my-1">
                                    <label htmlFor="" className="fs-6">Prénoms & Nom</label>
                                    <input type="text" className="form-control" name="nom_complet" value={nom} required />
                                    {errors?.nom_complet && <span className="text-danger mt-2">{errors?.nom_complet}</span>}
                                </div>
                                <div className="form-group my-1">
                                    <label htmlFor="" className="fs-6">Genre</label>
                                    <select name="genre" id="genre" className="form-select" required>
                                        <option value="">Votre choix</option>
                                        <option value="Homme">Homme</option>
                                        <option value="Femme">Femme</option>
                                    </select>
                                    {errors?.nom_complet && <span className="text-danger mt-2">{errors?.nom_complet}</span>}
                                </div>
                                <div className="form-group my-1">
                                    <label htmlFor="" className="fs-6">Téléphone</label>
                                    <input type="number" className="form-control hide-arrow" name="telephone" value={telephone} required />
                                    {errors?.telephone && <span className="text-danger mt-2">{errors?.telephone}</span>}
                                </div>
                                <div className="form-group my-1">
                                    <label htmlFor="" className="fs-6">Email</label>
                                    <input type="email" className="form-control" name="email" value={adresse}

                                    />
                                    {errors?.email && <span className="text-danger mt-2">{errors?.email}</span>}
                                </div>
                                <div className="form-group my-1">
                                    <label htmlFor="" className="fs-6">Adresse</label>
                                    <input type="text" className="form-control" name="adresse" value={adresse}

                                    />
                                    {errors?.adresse && <span className="text-danger mt-2">{errors?.adresse}</span>}
                                </div>



                            </div>


                            {loader && <Loading />}
                        </div>
                        <div className="modal-footer">
                            <a className="btn btn-danger" data-bs-dismiss="modal" ref={ref}>Annuler</a>
                            <button type="submite" disabled={loader} className="btn btn-success">Enregistrer</button>
                        </div>
                    </form>
                </div>

            </div>
        </div>
    );
}

export default ModalAddPartenaire;